import ChangePassword from './containers/ChangePassword';
import { IndexRoute } from 'react-router';
import React from 'react';

export { uiDataChangePassword, serverDataChangePassword } from './reducers/ChangePassword';
export default ChangePassword;